import React, { useEffect,useState } from 'react'
import Firstslide from '../../Assets/Firstslide.png';
import Secondslide from '../../Assets/Secondslide.webp';
import Thirdslide from '../../Assets/Thirdsilde.webp';
import Fourthslide from '../../Assets/Fourthslide.webp';
import'./home.css'
import InterShipData from '../Data/InternshipDatAvl';
import JobData from '../Data/JobsDataAvl';
import CertificationData from '../Data/CertificationData';
import asdfgh from '../../Assets/internsala.png';
import Axios from '../../Axios';
import {Link} from 'react-router-dom';



function Home() {

  const data= InterShipData;
  console.log(data)
  
  const data1= JobData;
  console.log(data1)

  const data2=CertificationData;
  console.log(data2)
  
  return (
        <>
      <h1 className='head'>
        Make your dream carrer a reality
      </h1>
      <span className='Underline'></span>
        <div className="head2">
        Trending on InternArea 🔥
        </div>
      
      <div className="imgs " id="container">
        <div className="slide flex justify-center">
        <img className='slide_Img'src={Firstslide} alt=""/>
             <img className='slide_Img'src={Secondslide} alt=""/>
            <img className='slide_Img'src={Thirdslide} alt=""/>
            <img className='slide_Img'src={Fourthslide} alt=""/>
            <img className='slide_Img'src={Firstslide} alt=""/>
             <img className='slide_Img'src={Secondslide} alt=""/>
            <img className='slide_Img'src={Thirdslide} alt=""/>
            <img className='slide_Img'src={Fourthslide} alt=""/>
            
        </div>
        
        
        
      </div>
        <div className="infoys">
            <div className="info-intern">
              <div className="mt-16">
                <h1 className='head3'>Latest Internship on Intern Area</h1>
              </div>
              
              <div className="categories flex flex-wrap mt-14">
                <p>POPULAR CATEGORIES </p>
                
                <span className='Category mr-4'>Big Brand</span>
                 <span className='Category mr-4'>Work for Home </span>
                 <span className='Category mr-4'>Part time</span>
                 <span className='Category mr-4'>MBA</span>
                 <span className='Category mr-4'>Engineering</span>
                 <span className='Category mr-4'>Media</span>
                 <span className='Category mr-4'>Design</span>
                 <span className='Category mr-4'>Data Science</span>
              </div>
            </div>
        </div>
      <div className='flex' id="Interncard">
        
      {data.map((elm,index)=>(
          <div className="job-card " key={index}>
          <div className="header">
            <span className="hiring-status"><i class="bi bi-arrow-up-right"></i>Actively hiring</span>
          </div>
          
            
          <h2 className="title">{elm.title}</h2>
          <p className="company">{elm.company}</p>
          <div className="picture">
          <img src={asdfgh} alt=""  style={{height:"30px", width:"50px"}}/>
      
          </div>
          <div className="underline"> </div>
          <div className="location"><i class="bi bi-geo-alt"></i>{elm.location}</div>
          <div className="salary"><i class="bi bi-cash-stack"></i>{elm.stipend}</div>
          <div className="duration"><i class="bi bi-calendar"></i>{elm.Duration}</div>
          <div className="tag">Internship</div>
          <button className="details-button"><a href="#" className="details-link">View details</a></button>
        </div>
      ))}
      </div>
      <div className="infoys">
            <div className="info-intern">
              <div className="mt-16">
                <h1 className='head3'>Latest Jobs on Intern</h1>
              </div>
              
              <div className="categories flex flex-wrap mt-14">
                <p>POPULAR CATEGORIES </p>
                
                <span className='Category mr-4'>Big Brand</span>
                 <span className='Category mr-4'>Work for Home </span>
                 <span className='Category mr-4'>Part time</span>
                 <span className='Category mr-4'>MBA</span>
                 <span className='Category mr-4'>Engineering</span>
                 <span className='Category mr-4'>Media</span>
                 <span className='Category mr-4'>Design</span>
                 <span className='Category mr-4'>Data Science</span>
              </div>
            </div>
        </div>
        <div className='flex' id="Jobcard">
      {data1.map((elm,index)=>(
          <div className="job-card " key={index}>
          <div className="header">
            <span className="hiring-status"><i class="bi bi-arrow-up-right"></i>Actively hiring</span>
          </div>
          <h2 className="title">{elm.title}</h2>
          <p className="company">{elm.company}</p>
          
          <div className="underline"> </div>
          <div className="location"><i class="bi bi-geo-alt"></i>{elm.location}</div>
          <div className="salary"><i class="bi bi-cash-stack"></i>{elm.CTC}</div>
          <div className="duration"><i class="bi bi-calendar"></i>{elm.Experience}</div>
          <div className="tag">Jobs</div>
          <button className="details-button"><a href="#" className="details-link">View details</a></button>
        </div>
      ))}
      </div>
      
       
      <div className="head4">
            <h2><b>Certification Courses</b></h2>
            <p>Fastest way to build your CV</p>
          </div>

      <div className='flex w-[1350px] flex-wrap justify-center ' id="Certificate">
      {data2.map((elm,index)=>(
          <div className="Certification " key={index}>
          <div className="header">
          <div className="img">
             <img src={elm.picture} alt=" " />
             </div>
          </div>
          <div className="underline"> </div>
          <div className="Duration">{elm.Duration}</div>
          <div className="title">{elm.title}</div>
          <div className="rating">{elm.rating}</div>
          <div className="learners">{elm.learners}</div>  
          
          <div className="tag">Know more<i class="bi bi-chevron-right"></i></div>
          <button className="know">Know more<i class="bi bi-chevron-right"></i></button>
                
              </div>
              
          
      ))}
      <Link to="/Home"></Link>
      </div>
      <Axios/>
        </>
    

    
  )
}

export default Home;

